import range from 'lodash/range';

import {SectionItem} from 'common/components/items-menu/types';
import {getAlphaLabelFromIndex} from 'common/util';
import {RowLabelType} from 'common/query-builder/query-entry-section/types';
import {StepSelection} from 'common/report/funnels/models/types';

import {RangeSelection} from './types';

export function generateStepRanges({
  entry,
  steps,
  rowLabelType,
  disableAllSteps,
  singleStep,
}: {
  entry: StepSelection;
  steps: number;
  rowLabelType?: RowLabelType;
  disableAllSteps?: boolean;
  singleStep?: boolean;
}): Array<SectionItem & {value: RangeSelection}> {
  let hasMatch = false;
  const ranges = steps ? range(1, steps) : [];
  const {from: eventFrom, to: eventTo} = entry.range;

  const allEventsItem: SectionItem & {value: RangeSelection} = {
    isSelected: entry.isEntireRange,
    label: `All steps`,
    value: {isEntireRange: true, range: {}},
  };

  if (disableAllSteps) {
    allEventsItem.isDisabled = true;
    allEventsItem.tooltip = {text: `All steps is not supported for this chart`};
  }

  const rangeItems = ranges.map((i) => {
    const _range: RangeSelection['range'] = {from: i, to: i + 1};
    const isSelected = eventFrom === _range.from && eventTo === _range.to;
    hasMatch = hasMatch || isSelected;

    const from = rowLabelType === RowLabelType.Alpha ? getAlphaLabelFromIndex(_range.from - 1) : _range.from;
    const to = rowLabelType === RowLabelType.Alpha ? getAlphaLabelFromIndex(_range.to - 1) : _range.to;
    const label = singleStep ? `Step ${from}` : `Step ${from} \u2192 ${to}`;

    return {
      isSelected,
      label,
      value: {isEntireRange: false, range: _range},
    };
  });

  // if event has no match, it means a multi step
  // range was previously selected
  if (!entry.isEntireRange && !hasMatch) {
    rangeItems.push({
      isSelected: true,
      label: `Step ${eventFrom} \u2192 Step ${eventTo}`,
      value: {isEntireRange: false, range: entry.range},
    });
  }

  return [allEventsItem, ...rangeItems];
}
